<template>
	<div class="appointment">
		<div class="appointment__container">
			<h1 class="appointment__container-title">Solicitud de cita</h1>
			<span v-if="acceptSuccess || rejectSuccess" class="appointment__container-icon-success">&#10004;</span>
			<span v-else class="appointment__container-icon-error">&#10006;</span>
			<h2 v-if="acceptSuccess" class="appointment__container-text">Cita aceptada</h2>
			<h2 v-else-if="rejectSuccess" class="appointment__container-text">Cita rechazada</h2>
			<h2 v-else class="appointment__container-text">Ha ocurrido un error</h2>
		</div>
		<div class="appointment__logo-container">
			<img class="appointment__logo" src="@/assets/images/feriavalencia-logo.png" alt="Logo" />
			<span>Feria Valencia</span>
		</div>
	</div>
</template>

<script>
import { acceptHash, rejectHash } from '@/components/appointment/AppointmentActions';

export default {
	name: 'Appointment',

	data() {
		return {
			profile: null,
			hash: null,
			acceptSuccess: false,
			rejectSuccess: false
		};
	},

	mounted() {
		this.checkURL();
	},

	methods: {
		checkURL: function () {
			this.profile = this.$route.query.profile;
			this.hash = this.$route.query.hash;
			if (this.$route.params.method === 'acceptHash') this.accept();
			else if (this.$route.params.method === 'rejectHash') this.reject();
		},

		accept: async function () {
			const response = await acceptHash(this.profile, this.hash);
			if (response === 'Appointment accepted') this.acceptSuccess = true;
		},

		reject: async function () {
			const response = await rejectHash(this.profile, this.hash);
			if (response === 'Appointment rejected') this.rejectSuccess = true;
		}
	},

	components: {}
};
</script>

<style lang="scss" scoped>
.appointment {
	background-color: #166bf2;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100vh;

	&__container {
		background-color: #fff;
		border-radius: 8px;
		display: flex;
		flex-direction: column;
		text-align: center;
		box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
		padding: 3rem 7rem;

		&-title {
			font-size: 2.25rem;
			padding: 1rem 0;
		}

		&-icon-success {
			color: green;
			font-size: 8rem;
		}
		&-icon-error {
			color: red;
			font-size: 8rem;
		}

		&-text {
			font-size: 1.75rem;
			padding: 1rem 0;
			font-weight: normal;
		}
	}

	&__logo {
		height: 9rem;

		&-container {
			position: absolute;
			bottom: 0;
			display: flex;
			align-items: center;

			& > span {
				color: #fff;
				font-size: 3rem;
				margin-left: 1rem;
				font-weight: bold;
			}
		}
	}
}
</style>
